module.exports = __webpack_public_path__ + "static/media/competitive-salary.75a29038.svg";